// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-size: cover;
  display: table-cell;
  height: 100%;
  vertical-align: middle;
  width: 100%;
}
:host card {
  margin: 0 auto;
  max-width: 400px;
}
:host card ::ng-deep .card-wrap {
  border: 0;
}
:host card form button {
  width: 100%;
}
:host card form .additional-info {
  background: rgba(0, 0, 0, 0.1);
  margin: 1.5714286rem -1.5714286rem -1.5714286rem;
  padding: 0.7857143rem 1.5714286rem;
}
:host card form .additional-info .divider {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  display: inline-block;
  height: 18px;
  margin: 0 10px;
  vertical-align: bottom;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/extra-pages/sign-in-1/sign-in-1.component.scss"],"names":[],"mappings":"AAEA;EAEE,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAFF;AAIE;EACE,cAAA;EACA,gBAAA;AAFJ;AAII;EACE,SAAA;AAFN;AAKM;EACE,WAAA;AAHR;AAKM;EACE,8BAAA;EACA,gDAAA;EACA,kCAAA;AAHR;AAKQ;EACE,yCAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AAHV","sourcesContent":["@import '../../../../assets/sass/variable';\r\n\r\n:host {\r\n  // background: url(../../../../assets/content/login-bg.jpg) 50% 50% no-repeat;\r\n  background-size: cover;\r\n  display: table-cell;\r\n  height: 100%;\r\n  vertical-align: middle;\r\n  width: 100%;\r\n\r\n  card {\r\n    margin: 0 auto;\r\n    max-width: 400px;\r\n\r\n    ::ng-deep .card-wrap {\r\n      border: 0;\r\n    }\r\n    form {\r\n      button {\r\n        width: 100%;\r\n      }\r\n      .additional-info {\r\n        background: rgba(#000,.1);\r\n        margin: $module (-$module) (-$module);\r\n        padding: $module/2 $module;\r\n\r\n        .divider {\r\n          border-left: 1px solid rgba(#000,.2);\r\n          display: inline-block;\r\n          height: 18px;\r\n          margin: 0 10px;\r\n          vertical-align: bottom;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
